"use client";

import type { ReactNode } from "react";
import { ScrollableRow } from "@/components/ui/scrollable-row";

export function LandingCardRow({ children }: { children: ReactNode }) {
  return (
    <ScrollableRow
      showIndicatorsOnDesktop
      arrowPlacement="flush"
      className="-mr-4 min-w-0 flex-1 sm:-mr-6 lg:-mr-[max(2rem,calc((100vw-var(--container-shell))/2+2rem))]"
      contentClassName="-my-6 -ml-6 snap-x snap-proximity py-6 pl-6 scroll-pl-6"
    >
      <div className="flex gap-[15px] pr-4 [&>*]:w-[171px] [&>*]:shrink-0 [&>*]:snap-start sm:pr-6 sm:[&>*]:w-[260px] lg:pr-[max(2rem,calc((100vw-var(--container-shell))/2+2rem))]">
        {children}
      </div>
    </ScrollableRow>
  );
}
